<template>
  <div class="container mx-auto my-8 px-4 lg:px-0">

    <div class="mb-8 flex flex-wrap flex-col-reverse lg:flex-row justify-between items-center">
      <search-input
        class="w-full lg:max-w-sm mr-0 lg:mr-4 shadow"
        placeholder="Zoeken op naam.."
        @searched="onSearched">
      </search-input>
      <div class="buttons mb-6 lg:mb-0 self-start lg:self-center" v-if="$sanmer.isAllowed('create')">
        <router-link :to="{ name: 'sanmer-new' }" class="btn py-3 text-sm text-white bg-green-dark font-semibold">
          <span>Nieuw</span>
          <span class="hidden md:inline ml-1">Saneerder</span>
        </router-link>
      </div>
    </div>

    <div class="bg-white shadow overflow-auto">
      <table class="custom w-full whitespace-no-wrap">
        <thead>
          <tr class="text-left text-green-darker">
            <th class="px-6">Naam</th>
            <th class="px-6">Gemaakt op</th>
            <th class="px-6" colspan="2">Gewijzigd op</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sanmer in sanmers.data" :key="sanmer.id" class="hover:bg-grey-lightest text-grey-darker">
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'sanmer', params: { id: sanmer.id } }" class="flex items-center px-6 py-4">
                {{ sanmer.name }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'sanmer', params: { id: sanmer.id } }" class="flex items-center px-6 py-4">
                {{ sanmer.created_at }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'sanmer', params: { id: sanmer.id } }" class="flex items-center px-6 py-4">
                {{ sanmer.updated_at }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter w-px">
              <router-link :to="{ name: 'sanmer', params: { id: sanmer.id } }" class="flex items-center px-6 py-4">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="icon" />
              </router-link>
            </td>
          </tr>
          <tr v-if="sanmers.data && sanmers.data.length === 0">
            <td class="border-t border-grey-lighter px-6 py-4" colspan="4">Geen saneerders gevonden.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <base-pagination
      class="mt-2"
      v-if="sanmers.meta && sanmers.meta.last_page > 1"
      :total-pages="sanmers.meta.last_page"
      :total="10"
      :current-page="sanmers.meta.current_page"
      @page-changed="onPageChanged">
    </base-pagination>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import SanmerPerimeter from '@/perimeters/sanmer';
import SearchInput from '@/components/inputs/Search';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'sanmers',
  perimeters: [SanmerPerimeter],
  components: {
    FontAwesomeIcon,
    SearchInput
  },
  created() {
    this.fetch(this.$route.query.page);
  },
  data() {
    return {
      sanmers: {}
    };
  },
  methods: {
    fetch(page = 1) {
      let params = { page: page, sort: 'name' };

      return ApiService.query('/v1/sanmers', { params: params }).then(
        response => (this.sanmers = response.data)
      );
    },
    onPageChanged(page) {
      this.$router.push({ name: 'sanmers', query: { page: page } });
    },
    onSearched(keyword) {
      if (!keyword) {
        return this.fetch();
      }

      ApiService.get('/v1/sanmers', `search?filter[name]=${keyword}`).then(
        response => (this.sanmers = response.data)
      );
    }
  }
};
</script>
